var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { Notification } from "./Notification";
import { NOTIFICATION_WRAP } from "../../classConstants";
import { getClassName, scrollToRef } from "../../helpers";
import values from "lodash/values";
var NotificationWrap = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 !important;\n    margin: 0 0 15px !important;\n    list-style: none !important;\n    &:empty {\n        margin-bottom: 0 !important;\n    }\n"], ["\n    padding: 0 !important;\n    margin: 0 0 15px !important;\n    list-style: none !important;\n    &:empty {\n        margin-bottom: 0 !important;\n    }\n"])));
export var NotificationList = function (_a) {
    var items = _a.items, className = _a.className, _b = _a.shouldScrollToRef, shouldScrollToRef = _b === void 0 ? true : _b, onClose = _a.onClose, forwardedRef = _a.forwardedRef, props = __rest(_a, ["items", "className", "shouldScrollToRef", "onClose", "forwardedRef"]);
    var notificationsRef = React.useRef(null);
    items = items || [];
    React.useEffect(function () {
        if (!shouldScrollToRef)
            return;
        if (items.length) {
            scrollToRef(notificationsRef);
        }
    }, [items, shouldScrollToRef]);
    if (items.length <= 0) {
        return null;
    }
    return (React.createElement(NotificationWrap, __assign({ ref: notificationsRef }, props, { className: getClassName(className, NOTIFICATION_WRAP) }), values(items).map(function (item, i) { return React.createElement(Notification, { key: "notification" + i, index: i, item: item, onClose: onClose }); })));
};
var templateObject_1;
